import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"
import {
  Box,
  Divider,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { SignalCategories } from "applications/signal/constants";
import DetectionSettingEditForm from "applications/signal/components/DetectionSettingEditForm";
import ArrowBackButton from "applications/signal/components/ArrowBackButton";
import NotificationSettingEditForm from "applications/signal/components/NotificationSettingEditForm";

export default function SettingConditionEdit() {
  const [selectedCategory, setSelectedCategory] = useState<string>(Object.keys(SignalCategories)[0]);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const registeredFormData = state?.formData;

  useEffect(() => {
    if (registeredFormData) {
      // 編集から来た場合、signal_typeに応じてselectedCategoryを設定する
      for (const [categoryKey, category] of Object.entries(SignalCategories)) {
        for (const type of Object.values(category.types)) {
          if (type.ordinal === registeredFormData.signal_type) {
            setSelectedCategory(categoryKey);
            break;
          }
        }
      }
    }
  }, [registeredFormData]);

  const handleClickBack = () => {
    navigate("/signal/");
  }

  return (
    <>
      <ArrowBackButton onClick={handleClickBack} />
      <Box sx={{ maxWidth: 600, mx: "auto" }}>
        <Typography variant="h4" sx={{ mt: 2, mb: 2 }}>
          Signal設定 {registeredFormData ? "編集" : "新規作成"}
        </Typography>
        <InputLabel id="signal-category-select-helper-label">シグナルタイプカテゴリ</InputLabel>
        <Select
          labelId="signal-category-select-helper-label"
          id="signal-category-select-helper"
          value={selectedCategory}
          fullWidth
          sx={{ mb: 3 }}
          onChange={e => setSelectedCategory(e.target.value as string)}
        >
          {Object.entries(SignalCategories).map(([key, { label }]) => (
            <MenuItem key={key} value={key}>
              {label}
            </MenuItem>
          ))}
        </Select>
        <Divider sx={{ mb: 2 }} />
      </Box>
      { selectedCategory === 'notification' && <NotificationSettingEditForm registeredFormData={registeredFormData} /> }
      { selectedCategory === 'detection' && <DetectionSettingEditForm registeredFormData={registeredFormData} /> }
    </>
  )
}
